import React, { useCallback } from 'react';
import { Button, Tooltip } from '@chakra-ui/core';
import { useOperatorFilter } from '../contexts/OperatorFilterContext';

export const OperatorFilterToggle = () => {
  const { isFilterDisabled, setIsFilterDisabled, canDisableFilter } = useOperatorFilter();

  const handleToggle = useCallback(() => {
    const newValue = !isFilterDisabled;
    setIsFilterDisabled(newValue);
  }, [isFilterDisabled, setIsFilterDisabled]);

  if (!canDisableFilter) return null;

  return (
    <Tooltip label="Désactiver/Activer les filtres d'attribution">
      <Button
        ml={2}
        py={0}
        height="auto"
        colorScheme={isFilterDisabled ? "green" : "gray"}
        onClick={handleToggle}
      >
        {isFilterDisabled ? "Filtres désactivés" : "Filtres activés"}
      </Button>
    </Tooltip>
  );
}; 